import React from "react";

const Washing_23 = React.forwardRef(
  ({ width = "32", height = "32", viewBox = "0 0 32 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30 2H2V30H30V2ZM0 0V32H32V0H0Z"
          fill="black"
        />
        <path
          d="M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_23;
